@let message = busy.message();
@if (message) {
  <!-- aria-live="assertive" : l'écran se verrouille, un lecteur d'écran doit l'annoncer tout de suite. -->
  <div
    class="fixed inset-0 z-[1100] flex items-center justify-center bg-black/30"
    role="alert"
    aria-live="assertive"
    aria-busy="true"
    data-testid="busy-overlay">
    <div
      class="flex flex-col items-center gap-(--space-4) rounded-(--radius-lg) bg-surface-0 px-(--space-8) py-(--space-6) shadow-lg max-w-[28rem]">
      <p-progressSpinner [style]="{ width: '40px', height: '40px' }" strokeWidth="4" animationDuration="1s" />
      <p class="text-center text-(color:--text-secondary)">{{ message.key | transloco: message.params }}</p>
    </div>
  </div>
}
